import { Component, Input, OnInit, Renderer2 } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { first } from "rxjs/operators";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { SuiviDTO } from "src/app/mon-portefeuille/core/model/suivi-dto";
import { SommeTempsDTO } from "src/app/mon-portefeuille/core/model/somme-temps-dto";
import { SuiviDossierService } from "src/app/mon-portefeuille/core/service/suivi-dossier.service";
import { Request } from "src/app/parametrage/core/model/request";
import { RequestService } from "src/app/parametrage/core/service/request.service";

@Component({
  selector: "app-suivi",
  templateUrl: "./suivi.component.html",
  styleUrls: ["./suivi.component.scss"],
})
export class SuiviComponent implements OnInit {
  @Input() requestId;

  suivi: SuiviDTO[];
  somme: SommeTempsDTO;
  request: Request;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService,
    private _suiviDossierService: SuiviDossierService,
    private _requestService: RequestService
  ) {}

  ngOnInit() {
    this.getRequestById(this.requestId);
    this.getSuivi(this.requestId);
    this.getSommeTempsByRequestId(this.requestId);
  }

  getRequestById(requestId) {
    this._requestService.getRequestById(requestId).subscribe(
      (data) => {
        this.request = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getSommeTempsByRequestId(requestId) {
    this._suiviDossierService.getSommeTemps(requestId).subscribe(
      (data) => {
        this.somme = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getSuivi(requestId) {
    this._suiviDossierService.getSuivi(requestId).subscribe(
      (data) => {
        this.suivi = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  //

  getFormathours(millisec) {
    var totalHours,
      totalMinutes,
      totalSeconds,
      hours,
      minutes,
      seconds,
      result = "";
    totalSeconds = millisec / 1000;
    totalMinutes = totalSeconds / 60;
    totalHours = totalMinutes / 60;

    seconds = Math.floor(totalSeconds) % 60;
    minutes = Math.floor(totalMinutes) % 60;
    hours = Math.floor(totalHours) % 60;
    const days = (millisec / (1000 * 60 * 60 * 24)).toFixed(0);

    if (Number(days) != 0) {
      result += days + " jr: ";
    }

    if (hours !== 0) {
      result += hours + " hr: ";

      if (minutes.toString().length == 1) {
        minutes = "0" + minutes;
      }
    }

    result += minutes + " min ";

    if (seconds.toString().length == 1) {
      seconds = "0" + seconds;
    }

    result += seconds + " sec";

    return result;
  }

  dhm(ms) {
    const days = Math.floor(ms / (24 * 60 * 60 * 1000));
    const daysms = ms % (24 * 60 * 60 * 1000);
    const hours = Math.floor(daysms / (60 * 60 * 1000));
    const hoursms = ms % (60 * 60 * 1000);
    const minutes = Math.floor(hoursms / (60 * 1000));
    const minutesms = ms % (60 * 1000);
    const sec = Math.floor(minutesms / 1000);
    return days + " jr: " + hours + " hr: " + minutes + " min: " + sec + " sec";
  }

  /**
   * JS SCRIPT
   */
  functionJquery() {}
}
